const BLOB_SIZE = 1024;
const randomBinaryBlob = new Uint8Array(BLOB_SIZE);
let randomBinaryIndex = BLOB_SIZE * 8;
export function getRandomBinary() {
  randomBinaryIndex++;
  if (randomBinaryIndex >= BLOB_SIZE * 8) {
    // crypto.getRandomValues(randomBinaryBlob);
    for (let i = 0; i < BLOB_SIZE; i++) {
      randomBinaryBlob[i] = Math.floor(Math.random() * 255.0);
    }
    randomBinaryIndex = 0;
  }

  const blobIndex = randomBinaryIndex >> 3;
  const bitIndex = randomBinaryIndex & 7;

  return (randomBinaryBlob[blobIndex]! >> bitIndex) & 1;
}

/**
 * A pseudo-random function that takes any positive integer and returns a number between 0 and 1.
 * @param i - The input number.
 * @returns A number between 0 and 1.
 */
export function pseudoRandom(i: number): number {
  i = i ^ 61 ^ (i >>> 16);
  i = i + (i << 3);
  i = i ^ (i >>> 4);
  i = i * 0x27d4eb2d;
  i = i ^ (i >>> 15);
  return (i >>> 0) / 0xffffffff;
}

export function randomChance(
  /** [0,1] how likely the event is to happen */
  weight: number,
): boolean {
  return Math.random() < weight;
}
